// Dizionari delle pagine secondarie: serata, statistiche, dipendenti, clienti, impostazioni.
export const PAGE_D = {
  it: {
    "g.loading": "Caricamento…", "g.save": "Salva", "g.edit": "Modifica", "g.cancel": "Annulla",
    "g.owner": "Pannello titolare", "g.config": "Configurazione", "g.search": "Cerca",
    "sr.title": "Serata", "sr.window": "Servizio dalle 05:00 alle 05:00",
    "sr.close": "Chiudi serata e azzera", "sr.closed": "Serata chiusa e archiviata",
    "sr.closedSub": "Tavoli liberati e disponibilità azzerate.",
    "sr.sold": "Venduto", "sr.cashed": "Incassato", "sr.discounts": "Sconti", "sr.openTables": "Tavoli aperti",
    "sr.closedTables": "{n} tavoli chiusi", "sr.avgTicket": "scontrino medio {v}",
    "sr.covers": "{n} coperti", "sr.waiters": "{n} camerieri attivi",
    "sr.hourly": "Incasso per fascia oraria", "sr.noClosed": "Nessun tavolo chiuso finora.",
    "sr.topDishes": "Classifica piatti", "sr.perWaiter": "Dettaglio per cameriere",
    "sr.waiter": "Cameriere", "sr.tables": "Tavoli", "sr.total": "Totale",
    "sr.takeaway": "Asporto e delivery", "sr.noTakeaway": "Nessun ordine fuori sala nella serata.",
    "sr.orders": "Ordini fuori sala", "sr.gross": "Lordo", "sr.fees": "Commissioni piattaforme",
    "sr.net": "Netto attività", "sr.chOrders": "{n} ordini", "sr.chNet": "{v} netti",
    "st.plan": "Piano Pro", "st.title": "Report vendite",
    "st.lockTitle": "Report vendite mensili",
    "st.lockDesc": "Andamento incassi, coperti, scontrino medio e classifica piatti su settimana e mese.",
    "st.lockMsg": "I report vendite mensili sono inclusi nel piano Pro",
    "st.week": "Settimana", "st.month": "Mese",
    "st.revenue": "Incassi", "st.covers": "Coperti", "st.avgTicket": "Scontrino medio",
    "st.series": "Andamento incassi", "st.best": "Piatti più venduti",
    "dp.title": "Dipendenti e credenziali",
    "dp.demoNote": "Nella demo i PIN sono visibili per farti provare i ruoli.",
    "dp.planNote": "Piano {plan}: {users} ({active} attivi).",
    "dp.limitUsers": "{n} utenti attivi", "dp.limitUser": "{n} utente attivo", "dp.unlimited": "utenti illimitati",
    "dp.namePh": "Nome e cognome", "dp.add": "Aggiungi", "dp.needName": "Inserisci il nome",
    "dp.added": "{name} aggiunto", "dp.addedSub": "Utente {username} · PIN {pin} — annotalo, non sarà più visibile",
    "dp.addFail": "Aggiunta non riuscita", "dp.editFail": "Modifica non riuscita",
    "dp.monitorOnly": "solo monitor", "dp.pinHidden": "PIN nascosto", "dp.locked": "bloccato",
    "dp.active": "Attivo", "dp.newPin": "Nuovo PIN",
    "dp.newPinOk": "Nuovo PIN di {name}: {pin}", "dp.newPinSub": "Annotalo ora: non sarà più visibile",
    "dp.removed": "Dipendente rimosso",
    "dp.state.attivo": "attivo", "dp.state.ferie": "ferie", "dp.state.malattia": "malattia", "dp.state.riposo": "riposo",
    "cl.title": "Clienti", "cl.new": "Nuovo cliente", "cl.editTitle": "Modifica cliente",
    "cl.needName": "Il nome è obbligatorio", "cl.saved": "Cliente salvato",
    "cl.name": "Nome", "cl.phone": "Telefono", "cl.email": "Email", "cl.address": "Indirizzo",
    "cl.fiscal": "Codice fiscale", "cl.notes": "Note (allergie, preferenze)", "cl.birthday": "Compleanno",
    "cl.searchPh": "Cerca per nome o telefono",
    "cl.visits": "Visite", "cl.spent": "Speso", "cl.avg": "Media",
    "cl.last": "Ultima visita {date} · {total}",
    "im.title": "Impostazioni", "im.name": "Nome attività",
    "im.nameHint": "Appare in intestazione, menu laterale e sul conto stampato.",
    "im.identity": "Identità del locale",
    "im.identityHint": "Il tuo motto e il tuo logo dentro l'app: lo staff li vede a ogni turno, i clienti sul conto.",
    "im.motto": "Il motto del locale",
    "im.mottoPh": "Es. Dal 1962, la pizza si fa a mano",
    "im.mottoHint": "Massimo 120 caratteri. Comparirà tra virgolette, in corsivo.",
    "im.logo": "Logo del locale", "im.logoHint": "PNG, JPG o SVG sotto i 300 KB.",
    "im.logoRemove": "Togli il logo", "im.logoTooBig": "Immagine troppo grande: restiamo sotto i 300 KB",
    "im.mottoLogin": "Mostralo nella schermata di accesso dello staff",
    "im.mottoBill": "Stampalo sul conto del cliente",
    "im.mottoMsg": "Aggiungilo ai messaggi per prenotazioni e lista d'attesa",
    "im.address": "Indirizzo", "im.vat": "Partita IVA", "im.phone": "Telefono", "im.cover": "Coperto (€)",
    "im.saveBtn": "Salva impostazioni", "im.needName": "Il nome attività è obbligatorio",
    "im.saved": "Impostazioni salvate",
    "im.demoTitle": "Informazioni sulla demo",
    "im.demoText": "Questa è una versione beta in sviluppo. Si entra scegliendo una persona, senza registrazione. Stampanti (Print Bridge) e Spesa e fornitori sono anteprime bloccate. Il logo personalizzato arriva nella versione completa.",
    "im.reset": "Ripristina dati demo", "im.resetOk": "Dati demo ripristinati",
    "pr.title": "Prenotazioni", "pr.quick": "Barra rapida",
    "pr.name": "Nome", "pr.mark": "Segna", "pr.needName": "Inserisci il nome",
    "pr.saveFail": "Salvataggio non riuscito", "pr.saved": "Prenotazione segnata",
    "pr.deleted": "Prenotazione eliminata",
    "pr.phone": "Telefono", "pr.zone": "Zona", "pr.table": "Tavolo",
    "pr.notePh": "Note (seggiolone, allergie)", "pr.today": "Oggi",
    "pr.state.attesa": "attesa", "pr.state.arrivata": "arrivata", "pr.state.annullata": "annullata",
    "as.overline": "Fuori sala", "as.title": "Asporto e delivery",
    "as.newTitle": "Nuovo ordine da asporto o delivery", "as.channel": "Canale",
    "as.created": "Ordine {n} creato", "as.createdSub": "Aggiungi i piatti e manda ai reparti.",
    "as.customer": "Nome cliente", "as.phone": "Telefono",
    "as.extCode": "Codice ordine piattaforma", "as.rider": "Rider",
    "as.address": "Indirizzo di consegna", "as.notePh": "Note (citofono, posate, allergie)",
    "as.ordersToday": "Ordini oggi", "as.gross": "Incasso lordo",
    "as.fees": "Commissioni", "as.net": "Netto attività",
    "as.none": "Nessun ordine da asporto per questo filtro.",
    "as.perChannel": "Resa per canale (oggi)", "as.chOrders": "Ordini",
    "as.chFee": "Commissione", "as.chNet": "Netto",
    "as.st.nuovo": "Nuovo", "as.st.in_preparazione": "In preparazione", "as.st.pronto": "Pronto",
    "as.st.ritirato": "Ritirato", "as.st.consegnato": "Consegnato",
    "as.all": "Tutti", "as.create": "Crea e prendi la comanda",
    "as.openOrder": "Apri comanda e conto",
    "as.itemsLine": "{n} articoli · {sent} inviati in cucina",
  },
  en: {
    "g.loading": "Loading…", "g.save": "Save", "g.edit": "Edit", "g.cancel": "Cancel",
    "g.owner": "Owner panel", "g.config": "Configuration", "g.search": "Search",
    "sr.title": "Tonight", "sr.window": "Service from 05:00 to 05:00",
    "sr.close": "Close the night and reset", "sr.closed": "Night closed and archived",
    "sr.closedSub": "Tables cleared and availability reset.",
    "sr.sold": "Sold", "sr.cashed": "Taken", "sr.discounts": "Discounts", "sr.openTables": "Open tables",
    "sr.closedTables": "{n} tables closed", "sr.avgTicket": "average bill {v}",
    "sr.covers": "{n} covers", "sr.waiters": "{n} active waiters",
    "sr.hourly": "Takings by hour", "sr.noClosed": "No table closed yet.",
    "sr.topDishes": "Dish ranking", "sr.perWaiter": "Breakdown per waiter",
    "sr.waiter": "Waiter", "sr.tables": "Tables", "sr.total": "Total",
    "sr.takeaway": "Takeaway and delivery", "sr.noTakeaway": "No off-premise order tonight.",
    "sr.orders": "Off-premise orders", "sr.gross": "Gross", "sr.fees": "Platform fees",
    "sr.net": "Net for the venue", "sr.chOrders": "{n} orders", "sr.chNet": "{v} net",
    "st.plan": "Pro plan", "st.title": "Sales reports",
    "st.lockTitle": "Monthly sales reports",
    "st.lockDesc": "Takings trend, covers, average bill and dish ranking over the week and the month.",
    "st.lockMsg": "Monthly sales reports are included in the Pro plan",
    "st.week": "Week", "st.month": "Month",
    "st.revenue": "Takings", "st.covers": "Covers", "st.avgTicket": "Average bill",
    "st.series": "Takings trend", "st.best": "Best sellers",
    "dp.title": "Staff and credentials",
    "dp.demoNote": "In the demo the PINs are visible so you can try every role.",
    "dp.planNote": "{plan} plan: {users} ({active} active).",
    "dp.limitUsers": "{n} active users", "dp.limitUser": "{n} active user", "dp.unlimited": "unlimited users",
    "dp.namePh": "First and last name", "dp.add": "Add", "dp.needName": "Enter the name",
    "dp.added": "{name} added", "dp.addedSub": "User {username} · PIN {pin} — write it down, it will not be shown again",
    "dp.addFail": "Could not add", "dp.editFail": "Could not update",
    "dp.monitorOnly": "monitor only", "dp.pinHidden": "PIN hidden", "dp.locked": "locked",
    "dp.active": "Active", "dp.newPin": "New PIN",
    "dp.newPinOk": "New PIN for {name}: {pin}", "dp.newPinSub": "Write it down now: it will not be shown again",
    "dp.removed": "Staff member removed",
    "dp.state.attivo": "active", "dp.state.ferie": "holiday", "dp.state.malattia": "sick leave", "dp.state.riposo": "day off",
    "cl.title": "Customers", "cl.new": "New customer", "cl.editTitle": "Edit customer",
    "cl.needName": "The name is required", "cl.saved": "Customer saved",
    "cl.name": "Name", "cl.phone": "Phone", "cl.email": "Email", "cl.address": "Address",
    "cl.fiscal": "Tax code", "cl.notes": "Notes (allergies, preferences)", "cl.birthday": "Birthday",
    "cl.searchPh": "Search by name or phone",
    "cl.visits": "Visits", "cl.spent": "Spent", "cl.avg": "Average",
    "cl.last": "Last visit {date} · {total}",
    "im.title": "Settings", "im.name": "Business name",
    "im.nameHint": "Shown in the header, the side menu and on the printed bill.",
    "im.identity": "Venue identity",
    "im.identityHint": "Your motto and logo inside the app: staff see them every shift, guests on the bill.",
    "im.motto": "Venue motto",
    "im.mottoPh": "E.g. Since 1962, pizza made by hand",
    "im.mottoHint": "Up to 120 characters. Shown in quotes, in italics.",
    "im.logo": "Venue logo", "im.logoHint": "PNG, JPG or SVG under 300 KB.",
    "im.logoRemove": "Remove the logo", "im.logoTooBig": "Image too large: keep it under 300 KB",
    "im.mottoLogin": "Show it on the staff sign-in screen",
    "im.mottoBill": "Print it on the guest bill",
    "im.mottoMsg": "Add it to booking and waiting-list messages",
    "im.address": "Address", "im.vat": "VAT number", "im.phone": "Phone", "im.cover": "Cover charge (€)",
    "im.saveBtn": "Save settings", "im.needName": "The business name is required",
    "im.saved": "Settings saved",
    "im.demoTitle": "About the demo",
    "im.demoText": "This is a beta version under development. You sign in by picking a person, no registration needed. Printers (Print Bridge) and Shopping and suppliers are locked previews. The custom logo comes with the full version.",
    "im.reset": "Restore demo data", "im.resetOk": "Demo data restored",
    "pr.title": "Reservations", "pr.quick": "Quick bar",
    "pr.name": "Name", "pr.mark": "Book", "pr.needName": "Enter the name",
    "pr.saveFail": "Could not save", "pr.saved": "Reservation booked",
    "pr.deleted": "Reservation deleted",
    "pr.phone": "Phone", "pr.zone": "Area", "pr.table": "Table",
    "pr.notePh": "Notes (highchair, allergies)", "pr.today": "Today",
    "pr.state.attesa": "expected", "pr.state.arrivata": "arrived", "pr.state.annullata": "cancelled",
    "as.overline": "Off premise", "as.title": "Takeaway and delivery",
    "as.newTitle": "New takeaway or delivery order", "as.channel": "Channel",
    "as.created": "Order {n} created", "as.createdSub": "Add the dishes and send them to the stations.",
    "as.customer": "Customer name", "as.phone": "Phone",
    "as.extCode": "Platform order code", "as.rider": "Rider",
    "as.address": "Delivery address", "as.notePh": "Notes (doorbell, cutlery, allergies)",
    "as.ordersToday": "Orders today", "as.gross": "Gross takings",
    "as.fees": "Fees", "as.net": "Net for the venue",
    "as.none": "No takeaway order for this filter.",
    "as.perChannel": "Yield per channel (today)", "as.chOrders": "Orders",
    "as.chFee": "Fee", "as.chNet": "Net",
    "as.st.nuovo": "New", "as.st.in_preparazione": "In preparation", "as.st.pronto": "Ready",
    "as.st.ritirato": "Collected", "as.st.consegnato": "Delivered",
    "as.all": "All", "as.create": "Create and take the order",
    "as.openOrder": "Open order and bill",
    "as.itemsLine": "{n} items · {sent} sent to the kitchen",
  },
  fr: {
    "g.loading": "Chargement…", "g.save": "Enregistrer", "g.edit": "Modifier", "g.cancel": "Annuler",
    "g.owner": "Espace propriétaire", "g.config": "Configuration", "g.search": "Rechercher",
    "sr.title": "Soirée", "sr.window": "Service de 05h00 à 05h00",
    "sr.close": "Clôturer la soirée et remettre à zéro", "sr.closed": "Soirée clôturée et archivée",
    "sr.closedSub": "Tables libérées et disponibilités remises à zéro.",
    "sr.sold": "Vendu", "sr.cashed": "Encaissé", "sr.discounts": "Remises", "sr.openTables": "Tables ouvertes",
    "sr.closedTables": "{n} tables clôturées", "sr.avgTicket": "ticket moyen {v}",
    "sr.covers": "{n} couverts", "sr.waiters": "{n} serveurs actifs",
    "sr.hourly": "Recettes par tranche horaire", "sr.noClosed": "Aucune table clôturée pour le moment.",
    "sr.topDishes": "Classement des plats", "sr.perWaiter": "Détail par serveur",
    "sr.waiter": "Serveur", "sr.tables": "Tables", "sr.total": "Total",
    "sr.takeaway": "À emporter et livraison", "sr.noTakeaway": "Aucune commande hors salle ce soir.",
    "sr.orders": "Commandes hors salle", "sr.gross": "Brut", "sr.fees": "Commissions des plateformes",
    "sr.net": "Net pour l'établissement", "sr.chOrders": "{n} commandes", "sr.chNet": "{v} nets",
    "st.plan": "Formule Pro", "st.title": "Rapports de ventes",
    "st.lockTitle": "Rapports de ventes mensuels",
    "st.lockDesc": "Évolution des recettes, couverts, ticket moyen et classement des plats sur la semaine et le mois.",
    "st.lockMsg": "Les rapports de ventes mensuels sont inclus dans la formule Pro",
    "st.week": "Semaine", "st.month": "Mois",
    "st.revenue": "Recettes", "st.covers": "Couverts", "st.avgTicket": "Ticket moyen",
    "st.series": "Évolution des recettes", "st.best": "Plats les plus vendus",
    "dp.title": "Personnel et identifiants",
    "dp.demoNote": "Dans la démo les codes sont visibles pour vous laisser essayer chaque rôle.",
    "dp.planNote": "Formule {plan} : {users} ({active} actifs).",
    "dp.limitUsers": "{n} utilisateurs actifs", "dp.limitUser": "{n} utilisateur actif", "dp.unlimited": "utilisateurs illimités",
    "dp.namePh": "Nom et prénom", "dp.add": "Ajouter", "dp.needName": "Saisissez le nom",
    "dp.added": "{name} ajouté", "dp.addedSub": "Utilisateur {username} · code {pin} — notez-le, il ne sera plus affiché",
    "dp.addFail": "Ajout impossible", "dp.editFail": "Modification impossible",
    "dp.monitorOnly": "écran seulement", "dp.pinHidden": "code masqué", "dp.locked": "bloqué",
    "dp.active": "Actif", "dp.newPin": "Nouveau code",
    "dp.newPinOk": "Nouveau code de {name} : {pin}", "dp.newPinSub": "Notez-le maintenant : il ne sera plus affiché",
    "dp.removed": "Employé supprimé",
    "dp.state.attivo": "actif", "dp.state.ferie": "congés", "dp.state.malattia": "maladie", "dp.state.riposo": "repos",
    "cl.title": "Clients", "cl.new": "Nouveau client", "cl.editTitle": "Modifier le client",
    "cl.needName": "Le nom est obligatoire", "cl.saved": "Client enregistré",
    "cl.name": "Nom", "cl.phone": "Téléphone", "cl.email": "E-mail", "cl.address": "Adresse",
    "cl.fiscal": "Numéro fiscal", "cl.notes": "Notes (allergies, préférences)", "cl.birthday": "Anniversaire",
    "cl.searchPh": "Rechercher par nom ou téléphone",
    "cl.visits": "Visites", "cl.spent": "Dépensé", "cl.avg": "Moyenne",
    "cl.last": "Dernière visite {date} · {total}",
    "im.title": "Paramètres", "im.name": "Nom de l'établissement",
    "im.nameHint": "Apparaît dans l'en-tête, le menu latéral et sur l'addition imprimée.",
    "im.identity": "Identité de l'établissement",
    "im.identityHint": "Votre devise et votre logo dans l'app : l'équipe les voit à chaque service, les clients sur l'addition.",
    "im.motto": "Devise de l'établissement",
    "im.mottoPh": "Ex. Depuis 1962, la pizza se fait à la main",
    "im.mottoHint": "120 caractères maximum. Affichée entre guillemets, en italique.",
    "im.logo": "Logo de l'établissement", "im.logoHint": "PNG, JPG ou SVG sous 300 Ko.",
    "im.logoRemove": "Retirer le logo", "im.logoTooBig": "Image trop lourde : restons sous 300 Ko",
    "im.mottoLogin": "L'afficher sur l'écran de connexion de l'équipe",
    "im.mottoBill": "L'imprimer sur l'addition du client",
    "im.mottoMsg": "L'ajouter aux messages de réservation et de liste d'attente",
    "im.address": "Adresse", "im.vat": "Numéro de TVA", "im.phone": "Téléphone", "im.cover": "Couvert (€)",
    "im.saveBtn": "Enregistrer les paramètres", "im.needName": "Le nom de l'établissement est obligatoire",
    "im.saved": "Paramètres enregistrés",
    "im.demoTitle": "À propos de la démo",
    "im.demoText": "Ceci est une version bêta en développement. On entre en choisissant une personne, sans inscription. Imprimantes (Print Bridge) et Achats et fournisseurs sont des aperçus verrouillés. Le logo personnalisé arrive avec la version complète.",
    "im.reset": "Restaurer les données de démo", "im.resetOk": "Données de démo restaurées",
    "pr.title": "Réservations", "pr.quick": "Barre rapide",
    "pr.name": "Nom", "pr.mark": "Noter", "pr.needName": "Saisissez le nom",
    "pr.saveFail": "Enregistrement impossible", "pr.saved": "Réservation notée",
    "pr.deleted": "Réservation supprimée",
    "pr.phone": "Téléphone", "pr.zone": "Zone", "pr.table": "Table",
    "pr.notePh": "Notes (chaise haute, allergies)", "pr.today": "Aujourd'hui",
    "pr.state.attesa": "attendue", "pr.state.arrivata": "arrivée", "pr.state.annullata": "annulée",
    "as.overline": "Hors salle", "as.title": "À emporter et livraison",
    "as.newTitle": "Nouvelle commande à emporter ou en livraison", "as.channel": "Canal",
    "as.created": "Commande {n} créée", "as.createdSub": "Ajoutez les plats et envoyez-les aux postes.",
    "as.customer": "Nom du client", "as.phone": "Téléphone",
    "as.extCode": "Code de commande plateforme", "as.rider": "Livreur",
    "as.address": "Adresse de livraison", "as.notePh": "Notes (interphone, couverts, allergies)",
    "as.ordersToday": "Commandes du jour", "as.gross": "Recette brute",
    "as.fees": "Commissions", "as.net": "Net pour l'établissement",
    "as.none": "Aucune commande à emporter pour ce filtre.",
    "as.perChannel": "Rendement par canal (aujourd'hui)", "as.chOrders": "Commandes",
    "as.chFee": "Commission", "as.chNet": "Net",
    "as.st.nuovo": "Nouvelle", "as.st.in_preparazione": "En préparation", "as.st.pronto": "Prête",
    "as.st.ritirato": "Récupérée", "as.st.consegnato": "Livrée",
    "as.all": "Toutes", "as.create": "Créer et prendre la commande",
    "as.openOrder": "Ouvrir la commande et l'addition",
    "as.itemsLine": "{n} articles · {sent} envoyés en cuisine",
  },
  de: {
    "g.loading": "Wird geladen…", "g.save": "Speichern", "g.edit": "Bearbeiten", "g.cancel": "Abbrechen",
    "g.owner": "Inhaber-Bereich", "g.config": "Konfiguration", "g.search": "Suchen",
    "sr.title": "Abend", "sr.window": "Service von 05:00 bis 05:00",
    "sr.close": "Abend abschließen und zurücksetzen", "sr.closed": "Abend abgeschlossen und archiviert",
    "sr.closedSub": "Tische freigegeben und Verfügbarkeit zurückgesetzt.",
    "sr.sold": "Umsatz", "sr.cashed": "Eingenommen", "sr.discounts": "Rabatte", "sr.openTables": "Offene Tische",
    "sr.closedTables": "{n} Tische abgeschlossen", "sr.avgTicket": "Durchschnittsbon {v}",
    "sr.covers": "{n} Gedecke", "sr.waiters": "{n} aktive Kellner",
    "sr.hourly": "Einnahmen nach Stunde", "sr.noClosed": "Noch kein Tisch abgeschlossen.",
    "sr.topDishes": "Gerichte-Ranking", "sr.perWaiter": "Aufstellung pro Kellner",
    "sr.waiter": "Kellner", "sr.tables": "Tische", "sr.total": "Gesamt",
    "sr.takeaway": "Abholung und Lieferung", "sr.noTakeaway": "Heute Abend keine Bestellung außer Haus.",
    "sr.orders": "Bestellungen außer Haus", "sr.gross": "Brutto", "sr.fees": "Plattform-Gebühren",
    "sr.net": "Netto für den Betrieb", "sr.chOrders": "{n} Bestellungen", "sr.chNet": "{v} netto",
    "st.plan": "Pro-Tarif", "st.title": "Verkaufsberichte",
    "st.lockTitle": "Monatliche Verkaufsberichte",
    "st.lockDesc": "Umsatzentwicklung, Gedecke, Durchschnittsbon und Gerichte-Ranking über Woche und Monat.",
    "st.lockMsg": "Monatliche Verkaufsberichte sind im Pro-Tarif enthalten",
    "st.week": "Woche", "st.month": "Monat",
    "st.revenue": "Einnahmen", "st.covers": "Gedecke", "st.avgTicket": "Durchschnittsbon",
    "st.series": "Umsatzentwicklung", "st.best": "Bestseller",
    "dp.title": "Personal und Zugangsdaten",
    "dp.demoNote": "In der Demo sind die PINs sichtbar, damit Sie jede Rolle testen können.",
    "dp.planNote": "Tarif {plan}: {users} ({active} aktiv).",
    "dp.limitUsers": "{n} aktive Benutzer", "dp.limitUser": "{n} aktiver Benutzer", "dp.unlimited": "unbegrenzte Benutzer",
    "dp.namePh": "Vor- und Nachname", "dp.add": "Hinzufügen", "dp.needName": "Namen eingeben",
    "dp.added": "{name} hinzugefügt", "dp.addedSub": "Benutzer {username} · PIN {pin} — notieren Sie sie, sie wird nicht mehr angezeigt",
    "dp.addFail": "Hinzufügen fehlgeschlagen", "dp.editFail": "Änderung fehlgeschlagen",
    "dp.monitorOnly": "nur Monitor", "dp.pinHidden": "PIN verborgen", "dp.locked": "gesperrt",
    "dp.active": "Aktiv", "dp.newPin": "Neue PIN",
    "dp.newPinOk": "Neue PIN von {name}: {pin}", "dp.newPinSub": "Jetzt notieren: sie wird nicht mehr angezeigt",
    "dp.removed": "Mitarbeiter entfernt",
    "dp.state.attivo": "aktiv", "dp.state.ferie": "Urlaub", "dp.state.malattia": "krank", "dp.state.riposo": "frei",
    "cl.title": "Kunden", "cl.new": "Neuer Kunde", "cl.editTitle": "Kunde bearbeiten",
    "cl.needName": "Der Name ist erforderlich", "cl.saved": "Kunde gespeichert",
    "cl.name": "Name", "cl.phone": "Telefon", "cl.email": "E-Mail", "cl.address": "Adresse",
    "cl.fiscal": "Steuernummer", "cl.notes": "Notizen (Allergien, Vorlieben)", "cl.birthday": "Geburtstag",
    "cl.searchPh": "Nach Name oder Telefon suchen",
    "cl.visits": "Besuche", "cl.spent": "Ausgegeben", "cl.avg": "Durchschnitt",
    "cl.last": "Letzter Besuch {date} · {total}",
    "im.title": "Einstellungen", "im.name": "Name des Betriebs",
    "im.nameHint": "Erscheint in der Kopfzeile, im Seitenmenü und auf der gedruckten Rechnung.",
    "im.identity": "Identität des Betriebs",
    "im.identityHint": "Ihr Motto und Ihr Logo in der App: das Team sieht sie in jeder Schicht, die Gäste auf der Rechnung.",
    "im.motto": "Motto des Betriebs",
    "im.mottoPh": "Z. B. Seit 1962 Pizza von Hand",
    "im.mottoHint": "Maximal 120 Zeichen. Erscheint in Anführungszeichen, kursiv.",
    "im.logo": "Logo des Betriebs", "im.logoHint": "PNG, JPG oder SVG unter 300 KB.",
    "im.logoRemove": "Logo entfernen", "im.logoTooBig": "Bild zu groß: unter 300 KB bleiben",
    "im.mottoLogin": "Auf dem Anmeldebildschirm des Teams zeigen",
    "im.mottoBill": "Auf die Gästerechnung drucken",
    "im.mottoMsg": "Zu Reservierungs- und Wartelisten-Nachrichten hinzufügen",
    "im.address": "Adresse", "im.vat": "USt-IdNr.", "im.phone": "Telefon", "im.cover": "Gedeck (€)",
    "im.saveBtn": "Einstellungen speichern", "im.needName": "Der Name des Betriebs ist erforderlich",
    "im.saved": "Einstellungen gespeichert",
    "im.demoTitle": "Über die Demo",
    "im.demoText": "Dies ist eine Beta-Version in Entwicklung. Der Einstieg erfolgt über die Auswahl einer Person, ohne Registrierung. Drucker (Print Bridge) sowie Einkauf und Lieferanten sind gesperrte Vorschauen. Das eigene Logo kommt mit der Vollversion.",
    "im.reset": "Demo-Daten wiederherstellen", "im.resetOk": "Demo-Daten wiederhergestellt",
    "pr.title": "Reservierungen", "pr.quick": "Schnellleiste",
    "pr.name": "Name", "pr.mark": "Eintragen", "pr.needName": "Namen eingeben",
    "pr.saveFail": "Speichern fehlgeschlagen", "pr.saved": "Reservierung eingetragen",
    "pr.deleted": "Reservierung gelöscht",
    "pr.phone": "Telefon", "pr.zone": "Bereich", "pr.table": "Tisch",
    "pr.notePh": "Notizen (Hochstuhl, Allergien)", "pr.today": "Heute",
    "pr.state.attesa": "erwartet", "pr.state.arrivata": "angekommen", "pr.state.annullata": "storniert",
    "as.overline": "Außer Haus", "as.title": "Abholung und Lieferung",
    "as.newTitle": "Neue Bestellung zur Abholung oder Lieferung", "as.channel": "Kanal",
    "as.created": "Bestellung {n} erstellt", "as.createdSub": "Gerichte hinzufügen und an die Stationen senden.",
    "as.customer": "Name des Kunden", "as.phone": "Telefon",
    "as.extCode": "Bestellcode der Plattform", "as.rider": "Fahrer",
    "as.address": "Lieferadresse", "as.notePh": "Notizen (Klingel, Besteck, Allergien)",
    "as.ordersToday": "Bestellungen heute", "as.gross": "Bruttoeinnahmen",
    "as.fees": "Gebühren", "as.net": "Netto für den Betrieb",
    "as.none": "Keine Abholbestellung für diesen Filter.",
    "as.perChannel": "Ertrag pro Kanal (heute)", "as.chOrders": "Bestellungen",
    "as.chFee": "Gebühr", "as.chNet": "Netto",
    "as.st.nuovo": "Neu", "as.st.in_preparazione": "In Zubereitung", "as.st.pronto": "Fertig",
    "as.st.ritirato": "Abgeholt", "as.st.consegnato": "Geliefert",
    "as.all": "Alle", "as.create": "Erstellen und Bestellung aufnehmen",
    "as.openOrder": "Bestellung und Rechnung öffnen",
    "as.itemsLine": "{n} Artikel · {sent} an die Küche gesendet",
  },
};
